import React, { memo } from 'react';

import { project_entry_path } from '~/routes';

export const valueGetter = (params) => {
  params.data ||= {};
  return (params.data[params.colDef.field] || {})["label"]
}
export const filterGetter = (params) => {
  return (params.data[params.colDef.field] || {})["id"]
}

const ProjectLinkCellRenderer = memo((params) => {
  const project_id = ((params.data || {})[params.colDef.field] || {})["id"] || params.data?.['project_id'];
  const href = project_id && project_entry_path({project_id: project_id});
  let label = params.getValue();
  label = label?.label || label;
  return href ? (
    <a
      href={href}
      onPointerDownCapture={(e) => e.stopPropagation()}
      onMouseDownCapture={(e) => e.stopPropagation()}
      onClickCapture={(e) => e.stopPropagation()}
    >
      {label}
    </a>
  ) : label || ''
});

export default ProjectLinkCellRenderer;